export default "__VITE_ASSET__CRZUnSSE__"